<li class="area-item" [class.selected]="isSelected()">
  @if (hasSubStructure() && !isSelected()) {
    <span class="area-name" (click)="handleNavigated($event)">
      {{ area().name | titlecase }}
      @if (nrOfChildren() > 0) {
        <span class="counter">
          <span>{{ nrOfChildren() }}</span>
        </span>
      }
    </span>
  } @else {
    <span class="area-name" [class.non-clickable]="true">
      @if (area().areaType === AreaType.PostcodeArea) {
        {{ postNumberWithAllDigits(area().number) }}
      }
      {{ area().name | titlecase }}
      @if (nrOfChildren() > 0) {
        <span class="counter">
          <span>{{ nrOfChildren() }}</span>
        </span>
      }
    </span>
  }
  @if (isSelectable() && !isSelected()) {
    <ev-button class="icon-area-actions" (onClick)="handleSelected($event)">
      <span class="icon icon-add"></span>
      <span class="label-add">Velg</span>
    </ev-button>
  } @else if (isSelectable() && isSelected()) {
    <ev-button class="icon-area-actions" (onClick)="handleUnselected($event)">
      <span class="icon icon-remove"></span>
      <span class="label-remove">Fjern</span>
    </ev-button>
  }
  @if (hasSubStructure() && !isSelected()) {
    <ev-button class="icon-button" (onClick)="handleNavigated($event)">
      <span class="icon icon-navigate"></span>
    </ev-button>
  } @else {
    <div class="button-placeholder"></div>
  }
</li>
